import { useTranslation } from 'react-i18next'
import { Modal, Button, Form, Input, InputNumber, message } from 'antd'
import { formRules } from 'utils'
import { Service } from 'services'

const CreateModal = props => {
    const { onSubmit, visible, onClose, nextPosition } = props
    const { t } = useTranslation()
    const [form] = Form.useForm()
    const rules = formRules(t)

    const handleFormSubmit = () => {
        form.validateFields()
            .then(values => {
                return Service.create.emailAttachment({
                    email_attachment: {
                        position: values.position,
                        url: values.url,
                    },
                })
            })
            .then(result => {
                message.success(t('general.feedback.create.title'))
                onSubmit(result)
                onClose()
            })
            .catch(err => {
                console.log(err)
                message.error(t('general.feedback.error.title'))
            })
    }

    return (
        <Modal
            title={t('attachment_page.create_title')}
            visible={visible}
            onCancel={onClose}
            width='50%'
            footer={[
                <Button key='close' type='primary' onClick={onClose}>
                    {t('general.actions.cancel')}
                </Button>,
                <Button key='submit' type='primary' htmlType='submit' form='attachmentCreateForm'>
                    {t('general.actions.submit')}
                </Button>,
            ]}
        >
            <article className='analysis-form'>
                <Form
                    form={form}
                    id='attachmentCreateForm'
                    layout='vertical'
                    onFinish={handleFormSubmit}
                    initialValues={{ position: nextPosition || 1 }}
                >
                    <div className='fields'>
                        <Form.Item
                            name='position'
                            label={t('attachment_page.position')}
                            rules={[rules.required]}
                        >
                            <InputNumber min={1} />
                        </Form.Item>

                        <Form.Item
                            name='url'
                            label={t('attachment_page.url')}
                            rules={[rules.required, rules.url]}
                            style={{ flexBasis: '100%' }}
                        >
                            <Input placeholder='https://' />
                        </Form.Item>
                    </div>
                </Form>
            </article>
        </Modal>
    )
}

export default CreateModal
